<template>
  <section class="ine-form">
    <Background />
    <TwoFactorForm
      :isLoading="isLoading"
      :isGoogleAuthenticatorMFA="!!isGoogleAuthenticatorMFA"
      @cancel-login="cancelLogin"
      @resend-mfa-code="resendMFACode"
      @submit-form="submitForm"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { removeAllTokens } from '@internetworkexpert/js-common'
import Background from '@/components/forms/elements/Background.vue'
import TwoFactorForm from '@/components/forms/TwoFactorForm.vue'

export default {
  name: 'TwoFactor',
  components: {
    Background,
    TwoFactorForm,
  },
  metaInfo() {
    return {
      title: `INE - Two Factor`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      isTwoFactorRequired: state => state.auth.isTwoFactorRequired,
      searchQuery: state => state.search.searchQuery,
      redirectUrl: state => state.auth.redirectUrl,
      isGoogleAuthenticatorMFA: state => state.auth.isGoogleAuthenticatorMFA,
    }),
  },
  methods: {
    async resendMFACode() {
      this.isLoading = true
      await this.$store.dispatch('auth/resendMFACode')
      this.$store.dispatch('app/setNotification', 'The code has been resent.')
      this.isLoading = false
    },
    async submitForm({ code }) {
      this.isLoading = true
      try {
        await this.$store.dispatch('auth/submitMFACode', code)
        if (this.isAuthenticated) {
          if (this.redirectUrl && this.redirectUrl.length) {
            window.location.assign(this.redirectUrl)
          } else {
            this.$router.push({ name: 'home' })
          }
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    async cancelLogin() {
      await removeAllTokens()
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
      this.$store.dispatch('auth/setRedirectUrl', '')
      this.$router.push({ name: 'home' })
    },
  },
  async created() {
    if (!this.isTwoFactorRequired) {
      this.$router.push({ name: 'login' })
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
    }
  },
}
</script>
